module.exports = __webpack_public_path__ + "media/images/about-logo-wsfr-20e086dc84ab91d4c2ebcee9d2089bf5.png";